import { API_BASE_URL } from "@/config";
import { BaseService } from "@/services/base-service";

import { AmazonianInfo } from "./user-info.types";

export class UserInfoService extends BaseService {
  constructor() {
    super(API_BASE_URL);
  }

  public async getUserInfo(): Promise<AmazonianInfo> {
    const response = await this.fetch("/user-info");
    if (!response.ok) {
      throw new Error(`Failed to fetch user info: ${response.status}`);
    }
    return (await response.json()) as AmazonianInfo;
  }
}
